import { render } from "./RolesByMerchant.vue?vue&type=template&id=2c1b062a&scoped=true"
import script from "./RolesByMerchant.vue?vue&type=script&lang=js"
export * from "./RolesByMerchant.vue?vue&type=script&lang=js"

import "./RolesByMerchant.vue?vue&type=style&index=0&id=2c1b062a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c1b062a"],['__file',"src/views/h5/common/basedata/role/RolesByMerchant.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2c1b062a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2c1b062a', __exports__)) {
    api.reload('2c1b062a', __exports__)
  }
  
  module.hot.accept("./RolesByMerchant.vue?vue&type=template&id=2c1b062a&scoped=true", () => {
    api.rerender('2c1b062a', render)
  })

}


export default __exports__